import React from 'react';
import { Checkbox, Grid, Typography, makeStyles } from '@material-ui/core';
import { RoleObjectPermissions } from 'modules/permission/interfaces';
import styles from './styles';
import PermissionCardItem from './PermissionCardItem';
import { PermissionHandleCheck, GroupPermission } from '../interfaces';

const useStyles = makeStyles(styles);

export interface PermissionCardProps {
  permissions?: RoleObjectPermissions;
  checked: string[];
  pending: string[];
  handleCheckAllExists: (values: string[]) => boolean;
  handleCheck: PermissionHandleCheck;
  setPending: (pending: string[]) => void;
  setChecked: (checked: string[]) => void;
  updatePermissions: (permissions: string[]) => void;
  groupPermissions: Array<GroupPermission>;
  entityKey: string;
}

const PermissionCard = ({
  permissions,
  pending,
  handleCheckAllExists,
  checked,
  setChecked,
  handleCheck,
  setPending,
  updatePermissions,
  groupPermissions,
  entityKey,
}: PermissionCardProps) => {
  const classes = useStyles();

  const handleToggleAllByTopic = (values: string[]) => {
    let newListPending = [...pending];
    values.forEach(value => {
      if (newListPending.includes(value)) {
        newListPending = newListPending.filter(item => item !== value);
      } else {
        newListPending = [...newListPending, value];
      }
    });
    setPending(newListPending);
    if (handleCheckAllExists(values)) {
      setChecked(checked.filter(permission => !values.includes(permission)));
      updatePermissions(
        checked.filter(permission => !values.includes(permission))
      );
    } else {
      setChecked([...checked, ...values]);
      updatePermissions([...checked, ...values]);
    }
  };

  return (
    <Grid
      container
      className={classes.twoContainers}
      data-testid="permission-card"
    >
      {groupPermissions?.map(groupPermission => (
        <Grid
          item
          xs={12}
          sm={6}
          className={classes.boxGrid}
          key={`group-${entityKey}-permission-${groupPermission?.key}`}
        >
          <Grid container className={classes.title}>
            <Checkbox
              size="small"
              checked={handleCheckAllExists(groupPermission?.values)}
              onChange={() => {
                handleToggleAllByTopic(groupPermission?.values);
              }}
              className={classes.checkIcon}
            />
            <Typography className={classes.titleText}>
              {groupPermission?.label}
              {':'}
            </Typography>
          </Grid>
          <Grid container>
            {permissions?.available &&
              groupPermission?.values.map(item => (
                <PermissionCardItem
                  key={item}
                  permission={item}
                  handleCheck={handleCheck}
                  pending={pending}
                />
              ))}
          </Grid>
        </Grid>
      ))}
    </Grid>
  );
};

export default PermissionCard;
